var FuseConfirmDialogModule = /** @class */ (function () {
    function FuseConfirmDialogModule() {
    }
    return FuseConfirmDialogModule;
}());
export { FuseConfirmDialogModule };
